import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { GetAllIngredients } from './../../../../../reduxToolkit/FoodieDishes/DishesApi';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const IngredientsApp = (setSelectedIngredients, ingredients) => {
    const dispatch = useDispatch();
    // Get all ingredients from the Redux store
    const { allIngredients } = useSelector((state) => state.DishSlice);
    // Fetch all ingredients once on mount
    useEffect(() => {
        dispatch(GetAllIngredients());
    }, []);
    // Map provided ingredient data to selection format
    useEffect(() => {
        if (ingredients && ingredients.length > 0) {
            const mapped = ingredients.map((i) => ({
                id: i.ingredientId,
                label: i.ingredientName,
                unit: i.quantity,
                subtitle: i.unit,
            }));
            setSelectedIngredients(mapped);
        }
    }, [ingredients]);
    return {
        allIngredients,
    };
};

export default IngredientsApp;
